export const delaware = {
  "10000": "Delaware",
  "10001": "Kent County",
  "10003": "New Castle County",
  "10005": "Sussex County",
};
